module.exports = __webpack_public_path__ + "static/img/icon4.aeb0f78.png";


//////////////////
// WEBPACK FOOTER
// ./src/common/images/dataCenter/icon4.png
// module id = lg+e
// module chunks = 1